import pym from "pym.js";
import * as d3 from "d3";
import d3tip from 'd3-tip';

import csv from '../data/data.csv';

let draw = () => {

  let l_prop = '% Qualify for Reduced or Free Lunch';
  d3.csv(csv).then(data => {
    let clean = data.filter(d => d[l_prop] == +d[l_prop] && d[l_prop].length > 0);

    let percentages = clean.map(d => Object.create({
      'admit': +d['Admitted'],
      'school': d['School'],
      'city': d['City'],
      'state': d['State'],
      'color': d['State'] === 'Michigan' ? '#374567' : '#E0AE4F',
      'p_lunch': +d[l_prop] * 100,
      'p_yield': +d['Yield'] * 100
    }));

    percentages.sort((a, b) => d3.descending(a.admit, b.admit))

    let percentFormat = d3.format('.3');

    let svg = d3.select('#graphic');

    const width = svg.select(function () {return this.parentNode}).node().offsetWidth;
    const height = 400;
    const margin = { top: 20, right: 20, bottom: 65, left: 30 };

    svg = svg
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', `translate(5, ${margin.top})`);

    let rad = d3.scaleLinear()
      .domain(d3.extent(percentages, d => d.admit))
      .range([3, 12]);

    let x = d3.scaleLinear()
      .domain([0, 100])
      .range([margin.left, width - margin.right]);

    const FEEDER_AVG = 17.5;
    const NATIONAL_AVG = 52.6;

    let xTicks = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, FEEDER_AVG, NATIONAL_AVG];

    let xAxis = g => g.call(d3.axisBottom(x).tickValues(xTicks).tickFormat(percentFormat))
      .call(g => g.append('text')
        .attr('x', width - margin.right)
        .attr('y', 40)
        .attr('fill', 'black')
        .attr('text-anchor', 'end')
        .attr('font-family', 'Open Sans')
        .text('% of students eligible for free or reduced lunch'))

    let customXAxis = g => {
      let s = g.selection ? g.selection() : g;
      g.call(xAxis);
      let customTicks = s.selectAll('.tick').filter((d, i) => i > 10);
      customTicks.selectAll('line')
        .attr('y1', -height + margin.bottom + margin.top)
        .attr('y2', 17)
        .attr('stroke-width', 2)
      customTicks.selectAll('text')
        .attr('dy', 17)
    }

    svg.append('g')
      .attr('transform', `translate(0, ${height - margin.bottom})`)
      .call(customXAxis);

    let y = d3.scaleLinear()
      .domain([0, 100])
      .range([height - margin.bottom, margin.top]);

    let yAxis = g => g.call(
      d3.axisRight(y).tickSize(width).tickFormat(d => `${d}%`)
    )
      .call(g => g.append('text')
        .attr('x', -5)
        .attr('fill', 'black')
        .attr('text-anchor', 'start')
        .attr('font-family', 'Open Sans')
        .text('Yield'));

    let customYAxis = g => {
      let s = g.selection ? g.selection() : g;
      g.call(yAxis);
      s.select('.domain').remove();
      s.selectAll('.tick line').filter(Number)
        .attr('stroke', '#c0c0c0')
        .attr('stroke-dasharray', '2,2')
      s.selectAll('.tick text')
        .attr('x', -5)
        .attr('dy', -5)
        .attr('text-anchor', 'start')
      if (s !== g) {
        g.selectAll('.tick text')
          .attrTween('x', null)
          .attrTween('dy', null);
      }
    }

    svg.append('g')
      .call(customYAxis)

    let tip = d3tip()
      .attr('class', 'd3-tip')
      .offset(d => [d.left ? 0 : d.right ? -5 : -10, d.left ? 10 : d.right ? -10 : 0])
      .direction(d => d.left ? 'e': d.right ? 'w' : 'n')
      .html((d) => `${d.data.school}<br>
                    ${d.data.city}, ${d.data.state}<br><br>
                    Admissions: ${d.data.admit}<br>
                    Yield: ${percentFormat(d.data.p_yield)}%<br>
                    Free/reduced lunch: ${percentFormat(d.data.p_lunch)}%`);

    svg.call(tip);

    svg.selectAll('circle')
      .data(percentages)
      .enter()
      .append('circle')
      .attr('cx', d => x(d.p_lunch))
      .attr('cy', d => y(d.p_yield))
      .attr('r', d => rad(d.admit))
      .attr('fill', d => d.color)
      .attr('fill-opacity', 0.7)
      .attr('stroke-width', 1.75)
      .on('mouseover', function (e, d) {
        let cx = d3.select(this).attr('cx')
        let left = cx < width * 0.2;
        let right = cx > width * 0.8;
        d3.select(this)
          .attr('stroke', 'black')
        tip.show({ data: d, left: left, right: right }, this)
      })
      .on('mouseleave', function() {
        d3.select(this)
          .attr('stroke', 'transparent')
        tip.hide()
      });

    let annotations = [{
      text: 'Feeder schools avg.',
      x: FEEDER_AVG,
      dx: -35,
    }, {
      text: 'US public school avg.',
      x: NATIONAL_AVG,
      dx: 0,
    }]

    svg.selectAll('.anno')
      .data(annotations)
      .enter()
      .append('text')
      .attr('class', 'anno')
      .attr('x', d => x(d.x))
      .attr('dx', d => d.dx)
      .attr('y', y(102.5))
      .text(d => d.text)

    let legend_circles = [160, 80, 2];

    let legend = svg.append('g')
      .attr('transform', `translate(
        ${width - 150}, 
        ${height - rad(160) - margin.bottom - 17.5})`)

    legend.selectAll('circle')
      .data(legend_circles)
      .enter()
      .append('circle')
      .attr('fill', 'none')
      .attr('stroke', 'black')
      .attr('cx', rad(legend_circles[0]))
      .attr('cy', rad)
      .attr('r', rad)

    legend.selectAll('line')
      .data(legend_circles)
      .enter()
      .append('line')
      .attr('stroke', 'black')
      .attr('stroke-dasharray', '2, 2')
      .attr('x1', rad(legend_circles[0]))
      .attr('x2', 5 + rad(legend_circles[0]) * 3)
      .attr('y1', d => rad(d) * 2)
      .attr('y2', d => rad(d) * 2)

    legend.selectAll('text')
      .data(legend_circles)
      .enter()
      .append('text')
      .attr('class', 'legend')
      .attr('dx', 6)
      .attr('dy', 3)
      .attr('x', 5 + rad(legend_circles[0] * 3))
      .attr('y', d => rad(d) * 2)
      .text((d, i) => i === 0 ? `${d} admissions` : d)
  })
}

const resize = () => { };

window.onload = function () {
  const pymChild = new pym.Child({ renderCallback: resize, polling: 500 });
  pymChild.sendHeight();

  draw();
};
